import { defineStore } from 'pinia';

export const useEnvProps = defineStore('envProps', {
  state: () => ({}),
  getters: {},
  actions: {},
});
